/* ---------------- INVESTOR PORTAL SCREENS ----------------
   The portal renders every screen itself; these are the URL slugs that map
   onto its internal screen ids. Declared here because MainLayout needs them
   to register the routes and the portal needs them to resolve the active
   screen from the URL, and the two must not drift apart.

   Each becomes a STATIC child of /home — e.g. /home/events. That matters:
   /home/:Id already exists for SpotlightDetails, and React Router v6 ranks a
   static segment above a dynamic one, so /home/events resolves to the portal
   while /home/a0xIo0000001abc still resolves to SpotlightDetails. Adding a
   slug here that collides with a real Salesforce id would break that, which
   is why the list is explicit rather than a wildcard.

   slug -> the portal's internal screen id (state.route). They differ only
   where the URL reads better than the internal name. */
export const PORTAL_SCREENS: Record<string, string> = {
  portfolio: 'portfolio',
  analytics: 'analytics',
  events: 'events',
  documents: 'documents',
  'ts-bridge': 'bridge',
  refer: 'refer',
  profile: 'profile',
  help: 'help',
  feed: 'feed',
  inbox: 'inbox',
  jury: 'jury',
};

/* The reverse lookup, for turning a screen id back into a URL. */
export const SCREEN_SLUGS: Record<string, string> = Object.keys(PORTAL_SCREENS)
  .reduce((acc: Record<string, string>, slug) => {
    acc[PORTAL_SCREENS[slug]] = slug;
    return acc;
  }, {});

const routes = {
  login: '/login',
  otpverification: '/otpverification',
  emailverification: '/emailverification',
  signup: '/signup',
  onboarding: '/onBoarding',
  forgotPassword: '/forgotPassword',
  changePassword: '/changePassword',
  home: '/home',

  mentorship: '/mentorship',
  groups: '/groups',
  discoverGroups: '/groups/discover-groups',
  createGroup: '/groups/create-group',
  network: '/network',
  survey: '/survey',
  createSurvey: '/survey/create-survey',
  test: '/test',
  
  RequestService: '/support/RequestService',
  Answers: '/support/Answers',
  TicketPreview: '/support/TicketPreview',
  connectSocials: '/connect-social',

  // profile
  profile: '/profile',
  profileDetails: '/profile/profile-details',

  // MyPortfolio
  myPortfolio: '/myPortfolio',
  fundPortfolioDetails: '/myPortfolio/fund-Portfolio-Details',
  recentReports: '/myPortfolio/recent-reports',
  engagementrSummaryDetails: "/myPortfolio/summary",
  // people
  ourTeam: '/ourTeam',
  ourInvestors: '/ourInvestors',

  // getInvolved
  getinvolved: '/getInvolved',

  // startups
  startups: '/TS-Global-Portfolio',

  // events
  events: '/events',
  eventDetail: '/events',
  hostEvent: '/events/hostevent',

  // COE
  coe: '/COE',

  //support 
  support: '/support',
  faqs:'/support/FAQs',

  // jury portal
  juryPortal: '/GIC-Portal',
  assignedStartups: '/GIC-Portal/assigned-startups',

  // Turbostart investor portal (TS Intelligence) — the ported prototype.
  // It routes internally off its own state, so one splat path covers all 12
  // of its screens and every co:/rpt:/ev:/doc:/opp: overlay pseudo-route.
  turbostart: '/turbostart',
};

export default routes;